import { Storage } from "./types";

export const initialStorage: Storage = {
  files: [],
  directories: [],
};
